/* eslint-disable */
import styles from './index.module.scss'
import Useful from '../../components/pages/useful'
import translate from '../../utils/translate.json'
import { t, calc3Dict, calc3Ext, calcCommon } from '../../utils/calculatorTranslations'
import { PageContext } from '../../context/PageContextProvider'
import { useParams } from 'react-router-dom'
import { useState, useContext, useEffect } from 'react'
import { Button, FormButton } from '../../components/core/button'
import PagesAPI from '../../api/pages'
import Loading from '../../components/pages/loading'
import StepLine from '../../components/core/stepLine'
import jsPDF from 'jspdf'
import { font } from '../../utils/font'
import { getWatermarkDataUrl } from '../../utils/watermark'
import {
  calculateMaternityBenefit2026,
  MAX_MONTHLY_LIMIT_2026,
} from '../Calculator3/maternityCalculator2026'

const formatCurrency = (val) => {
  const num = Number(val) || 0
  const [int, dec] = num.toFixed(2).split('.')
  return int.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + '.' + dec + ' ₼'
}

const Result3 = ({ className }) => {
  const params = useParams()
  const { language } = useContext(PageContext)
  const [load, setLoad] = useState(false)
  const [calcData, setCalcData] = useState(null)

  useEffect(() => {
    (async () => {
      try {
        await PagesAPI.getMagazinePageInfo()
      } catch (e) {}

      // Try reading from sessionStorage
      let stored = null
      try {
        const raw = sessionStorage.getItem('maternity_result_2026')
        if (raw) stored = JSON.parse(raw)
      } catch (e) {}

      if (stored && stored.finalBenefit !== undefined) {
        setCalcData(stored)
      } else {
        // Fallback: Reconstruct from URL params
        const sDate = params.start || new Date().toISOString().slice(0, 10)
        const tgs = parseInt(params.days_mezun) || 126
        const totalGross = parseFloat(params.total) || 0
        const perDay = parseFloat(params.per) || 0
        const benefit = parseFloat(params.muavinet) || (tgs * perDay)

        setCalcData({
          startDate: sDate,
          endDate: params.end || '',
          TGS: tgs,
          standardDays: tgs,
          delayDays: 0,
          seniorityMonths: 12,
          isEligibleSeniority: true,
          BTG: parseInt(params.days) || 365,
          ÜTG: parseInt(params.days) || 365,
          ÇTG: 0,
          totalMDSS: totalGross / 4,
          ÜQM: totalGross,
          OQM: perDay,
          rawBenefit: benefit,
          finalBenefit: benefit,
          monthlyAverage: perDay * (365 / 12),
          isCapNoticeApplicable: (perDay * (365 / 12)) > MAX_MONTHLY_LIMIT_2026,
          maxMonthlyLimit: MAX_MONTHLY_LIMIT_2026,
          quarterInfo: { quarters: [] },
          isSpecialClause2_9: false,
        })
      }
      setLoad(true)
    })()
  }, [])

  const steps = [
    {
      title: translate.calculation_type,
      text: translate.make_your_choice,
    },
    {
      title: translate.basic_information,
      text: translate.enter_info,
    },
    {
      title: translate.result,
      text: translate.ready,
    },
  ]

  const generatePdf = async () => {
    if (!calcData) return

    const watermarkData = await getWatermarkDataUrl()
    const pdf = new jsPDF('p', 'mm', 'a4')
    pdf.addFileToVFS('WorkSans-normal.ttf', font)
    pdf.addFont('WorkSans-normal.ttf', 'WorkSans', 'normal')
    pdf.setFont('WorkSans')

    // Watermark Background
    if (watermarkData) {
      pdf.addImage(watermarkData, 'PNG', 30, 110, 150, 46)
    }

    // Header
    pdf.setFontSize(16)
    pdf.setTextColor(22, 111, 229)
    pdf.text('BPG CONSULTING CENTRE', 20, 22)

    pdf.setFontSize(12)
    pdf.setTextColor(15, 23, 42)
    pdf.text('HAMİLƏLİK VƏ DOĞUMA GÖRƏ MÜAVİNƏTİN İLKİN HESABLANMASI PROTOKOLU', 20, 32)

    pdf.setFontSize(9)
    pdf.setTextColor(100, 116, 139)
    pdf.text(`Tarix: ${new Date().toLocaleDateString('az-AZ')}  |  Qanunvericilik: AR Əmək Məcəlləsi (Maddə 125) və NK-nin 189 nömrəli Qərarı`, 20, 38)
    pdf.line(20, 41, 190, 41)

    // Summary Highlight Box
    pdf.setFillColor(239, 246, 255)
    pdf.rect(20, 46, 170, 26, 'F')
    pdf.setDrawColor(191, 219, 254)
    pdf.rect(20, 46, 170, 26, 'S')

    pdf.setFontSize(10)
    pdf.setTextColor(29, 78, 216)
    pdf.text('HESABLANMIŞ MÜAVİNƏT MƏBLƏĞİ:', 25, 54)

    pdf.setFontSize(18)
    pdf.setTextColor(22, 111, 229)
    pdf.text(formatCurrency(calcData.finalBenefit), 25, 65)

    pdf.setFontSize(9)
    pdf.setTextColor(71, 85, 105)
    pdf.text('Gəlir vergisindən azad: Bəli (AR Vergi Məcəlləsi, Maddə 102.1.4).', 95, 64)

    // Key Parameters Table
    let y = 80
    pdf.setFontSize(11)
    pdf.setTextColor(15, 23, 42)
    pdf.text('1. Məzuniyyət və Staj Göstəriciləri', 20, y)
    y += 4

    const paramRows = [
      ['Məzuniyyət dövrü:', `${calcData.startDate} - ${calcData.endDate}`],
      ['Məzuniyyət müddəti (TGS):', `${calcData.TGS} təqvim günü (Standart: ${calcData.standardDays} gün${calcData.delayDays ? `, Gecikmə uzadılması: +${calcData.delayDays} gün` : ''})`],
      ['Fəaliyyət və Doğuş Kateqoriyası:', `${calcData.activityType === 'agriculture' ? 'Kənd təsərrüfatı' : 'Ümumi fəaliyyət'} / ${calcData.birthType === 'complicated' ? 'Çətinləşmiş' : calcData.birthType === 'multiple' ? 'Çoxdöllü' : 'Normal'}`],
      ['Sosial sığorta stajı:', `${calcData.seniorityMonths} ay (${calcData.isEligibleSeniority ? 'Hüquq şərti ödənilib' : 'Şərt ödənilməyə bilər - DSMF məlumatları əsas götürülür'})`],
      ['Bölən təqvim günləri (BTG):', `${calcData.BTG} gün (ÜTG: ${calcData.ÜTG} gün - ÇTG: ${calcData.ÇTG} gün)`],
      ['Orta gündəlik qazanc (OQM):', `${calcData.OQM.toFixed(2)} AZN / gün`],
      ['Aylıq qanuni maksimal hədd:', '8 000 AZN (Bənd 3.3 üzrə minimum pensiyanın 25 misli)'],
    ]

    pdf.setFontSize(9)
    paramRows.forEach(([lbl, val]) => {
      pdf.setTextColor(100, 116, 139)
      pdf.text(lbl, 22, y + 4)
      pdf.setTextColor(15, 23, 42)
      pdf.text(val, 90, y + 4)
      pdf.line(20, y + 6, 190, y + 6)
      y += 8
    })

    // 4 Quarters Table if available
    if (calcData.quarterInfo && calcData.quarterInfo.quarters && calcData.quarterInfo.quarters.length) {
      y += 6
      pdf.setFontSize(11)
      pdf.setTextColor(15, 23, 42)
      pdf.text('2. Əvvəlki 4 Rüb Üzrə Sığorta Qazancı Protokolu (Bənd 2.7)', 20, y)
      y += 6

      pdf.setFillColor(248, 250, 252)
      pdf.rect(20, y, 170, 7, 'F')
      pdf.setFontSize(8)
      pdf.setTextColor(71, 85, 105)
      pdf.text('Rüb', 24, y + 5)
      pdf.text('Dövr', 58, y + 5)
      pdf.text('Təqvim günü', 105, y + 5)
      pdf.text('MDSS haqqı', 140, y + 5)
      pdf.text('Qazanc (x4)', 170, y + 5)
      y += 7

      calcData.quarterInfo.quarters.forEach((q) => {
        const qMDSS = calcData.quarterlyMDSS ? (parseFloat(calcData.quarterlyMDSS[q.key]) || 0) : 0
        const qEarn = qMDSS * 4
        pdf.text(q.label, 24, y + 5)
        pdf.text(`${q.startDate} - ${q.endDate}`, 58, y + 5)
        pdf.text(`${q.calendarDays} gün`, 105, y + 5)
        pdf.text(`${qMDSS.toFixed(2)} ₼`, 140, y + 5)
        pdf.text(`${qEarn.toFixed(2)} ₼`, 170, y + 5)
        pdf.line(20, y + 7, 190, y + 7)
        y += 7
      })

      // Total Row
      pdf.setFontSize(8)
      pdf.setTextColor(15, 23, 42)
      pdf.text('CƏMİ:', 24, y + 5)
      pdf.text(`${calcData.ÜTG} gün`, 105, y + 5)
      pdf.text(`${calcData.totalMDSS.toFixed(2)} ₼`, 140, y + 5)
      pdf.text(`${calcData.ÜQM.toFixed(2)} ₼`, 170, y + 5)
      y += 10
    }

    // Disclaimer in PDF
    y = Math.max(y + 6, 230)
    pdf.setFontSize(7.5)
    pdf.setTextColor(100, 116, 139)
    pdf.text('Hüquqi Qeyd: Bu kalkulyator məlumatlandırıcı və ilkin hesablama məqsədi daşıyır.', 20, y)
    pdf.text('Faktiki müavinətin təyin edilməsi və məbləği sığortaolunanın DSMF/ƏMAS elektron məlumatları', 20, y + 4)
    pdf.text('və həmin tarixdə qüvvədə olan qanunvericilik əsasında müəyyən edilir.', 20, y + 8)
    pdf.text('BPG Consulting Centre  |  bpgconsulting.az  |  info@bpgconsulting.az', 20, y + 13)

    pdf.save(`BPG_Hamilelik_Muavineti_${calcData.startDate}.pdf`)
  }

  return load && calcData ? (
    <section className={`${styles.container} ${className || ''}`}>
      <Useful search={false} />
      <div className={styles.stepline}>
        <StepLine active={2} data={steps} />
      </div>

      <h1 className={styles.pageTitle}>
        {language === 'TR' ? 'Doğum ve Gebelik Ödeneği Hesaplama Sonucu' : language === 'ENG' ? 'Maternity Benefit Calculation Result' : language === 'RU' ? 'Результат расчета пособия по беременности и родам' : 'Hamiləliyə və Doğuma Görə Müavinətin Hesablama Nəticəsi'}
      </h1>

      {/* Hero Stats Grid */}
      <div className={styles.resultGrid}>
        <div className={`${styles.statCard} ${styles.heroCard}`}>
          <div>
            <div className={styles.cardLabel}>{t(calc3Dict.totalBenefitCard, language)}</div>
            <div className={`${styles.cardValue} ${styles.primary}`}>
              {formatCurrency(calcData.finalBenefit)}
            </div>
          </div>
          <div className={styles.cardSub}>
            {t(calc3Dict.taxExemptNotice, language)}
          </div>
        </div>

        <div className={styles.statCard}>
          <div>
            <div className={styles.cardLabel}>{language === 'TR' ? 'İzin Süresi (TGS)' : language === 'ENG' ? 'Leave Duration (TGS)' : language === 'RU' ? 'Срок отпуска (TGS)' : 'Məzuniyyət Müddəti (TGS)'}</div>
            <div className={styles.cardValue}>
              {calcData.TGS} <span>{t(calcCommon.days, language)}</span>
            </div>
          </div>
          <div className={styles.cardSub}>
            {t(calc3Ext.period, language)} <strong>{calcData.startDate}</strong> – <strong>{calcData.endDate}</strong>
            {calcData.delayDays > 0 && ` (Doğuş gecikməsi: +${calcData.delayDays} gün)`}
          </div>
        </div>

        <div className={styles.statCard}>
          <div>
            <div className={styles.cardLabel}>{language === 'TR' ? 'Ortalama Günlük Kazanç (OQM)' : language === 'ENG' ? 'Average Daily Earnings (OQM)' : language === 'RU' ? 'Среднедневной заработок (OQM)' : 'Orta Gündəlik Qazanc (OQM)'}</div>
            <div className={`${styles.cardValue} ${styles.success}`}>
              {calcData.OQM.toFixed(2)} <span>₼ / gün</span>
            </div>
          </div>
          <div className={styles.cardSub}>
            {t(calc3Ext.formula, language)} <strong>OQM = ÜQM / BTG</strong> ({calcData.ÜQM.toFixed(2)} ₼ / {calcData.BTG} gün)
          </div>
        </div>

        <div className={styles.statCard}>
          <div>
            <div className={styles.cardLabel}>{language === 'TR' ? 'Aylık Yasal Tavan (Madde 3.3)' : language === 'ENG' ? 'Monthly Legal Cap (Clause 3.3)' : language === 'RU' ? 'Месячный лимит (Пункт 3.3)' : 'Aylıq Qanuni Hədd (Bənd 3.3)'}</div>
            <div className={styles.cardValue}>
              8 000 <span>₼ / ay</span>
            </div>
          </div>
          <div className={styles.cardSub}>
            Qaydanın 3.3-cü bəndi: aylıq məbləğ minimum pensiyanın 25 mislindən artıq ola bilməz.
          </div>
        </div>
      </div>

      {/* 8 000 AZN Notice if applicable */}
      {calcData.isCapNoticeApplicable && (
        <div style={{
          width: 'calc(100% - 32px)',
          maxWidth: 1216,
          background: '#fffbeb',
          borderLeft: '4px solid #f59e0b',
          borderRadius: 8,
          padding: '16px 20px',
          marginBottom: 24,
          fontSize: 14,
          lineHeight: 1.5,
          color: '#92400e'
        }}>
          <strong>{t(calc3Ext.capNoticeTitle, language)}</strong> Qaydanın 3.3-cü bəndinə əsasən, hamiləliyə və doğuma görə müavinətin aylıq məbləği minimum əmək pensiyasının 25 mislindən (8 000 AZN) artıq ola bilməz. Hesablanmış göstərici bu həddi aşdıqda, yekun faktiki məbləğ DSMF-nin elektron sistemi və tətbiq olunan qanunvericilik əsasında müəyyən edilir.
        </div>
      )}

      {/* Seniority notice if under 6 months */}
      {!calcData.isEligibleSeniority && (
        <div style={{
          width: 'calc(100% - 32px)',
          maxWidth: 1216,
          background: '#fef2f2',
          borderLeft: '4px solid #ef4444',
          borderRadius: 8,
          padding: '16px 20px',
          marginBottom: 24,
          fontSize: 14,
          lineHeight: 1.5,
          color: '#991b1b'
        }}>
          <strong>⚠️ 6 aylıq sosial sığorta stajı şərti üzrə xəbərdarlıq:</strong> Sosial sığorta stajı 6 aydan azdır ({calcData.seniorityMonths} ay). Hesablanmış məbləğ yalnız riyazi göstəricidir. Müavinət alma hüququ və faktiki məbləğ DSMF/ƏMAS məlumatları və tətbiq olunan qanunvericilik əsasında müəyyən edilir.
        </div>
      )}

      {/* Audit Protocol Card */}
      <div className={styles.auditSection}>
        <div className={styles.auditTitle}>
          <span>{language === 'TR' ? 'Hesaplama Protokolü ve Temel Göstergeler' : language === 'ENG' ? 'Calculation Protocol & Base Metrics' : language === 'RU' ? 'Протокол расчета и базовые показатели' : 'Hesablama Protokolu və Baza Göstəriciləri'}</span>
          <span className={styles.badge}>NK 189 NÖMRƏLİ QƏRAR (2026 QAYDALARI)</span>
        </div>

        {/* 4 Quarters Table if available */}
        {calcData.quarterInfo && calcData.quarterInfo.quarters && calcData.quarterInfo.quarters.length > 0 && (
          <div className={styles.tableWrapper}>
            <table>
              <thead>
                <tr>
                  <th>{t(calc3Ext.quarter, language)}</th>
                  <th>{t(calc3Ext.calRange, language)}</th>
                  <th className={styles.num}>{t(calc3Ext.calDays, language)}</th>
                  <th className={styles.num}>{t(calc3Ext.eligibleMDSS, language)}</th>
                  <th className={styles.num}>Hesablanmış Qazanc (MDSS × 4)</th>
                </tr>
              </thead>
              <tbody>
                {calcData.quarterInfo.quarters.map((q) => {
                  const qMDSS = calcData.quarterlyMDSS ? (parseFloat(calcData.quarterlyMDSS[q.key]) || 0) : 0
                  const qEarn = qMDSS * 4
                  return (
                    <tr key={q.key}>
                      <td className={styles.bold}>{q.label}</td>
                      <td>{q.startDate} – {q.endDate}</td>
                      <td className={styles.num}>{q.calendarDays} gün</td>
                      <td className={styles.num}>{qMDSS.toFixed(2)} ₼</td>
                      <td className={styles.num}>{qEarn.toFixed(2)} ₼</td>
                    </tr>
                  )
                })}
                <tr className={styles.totalRow}>
                  <td colSpan={2}>{t(calc3Ext.totalSummary, language)}</td>
                  <td className={styles.num}>{calcData.ÜTG} gün (Faktiki ÜTG)</td>
                  <td className={styles.num}>{calcData.totalMDSS.toFixed(2)} ₼</td>
                  <td className={styles.num}>{calcData.ÜQM.toFixed(2)} ₼ (ÜQM)</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}

        <ul className={styles.summaryList}>
          <li>
            <span>{t(calc3Ext.totalCalDays, language)}</span>
            <strong>{calcData.ÜTG} gün</strong>
          </li>
          <li>
            <span>{t(calc3Ext.deductedCalDays, language)}</span>
            <strong>{calcData.ÇTG} gün</strong>
          </li>
          <li>
            <span>Bölən Təqvim Günləri (BTG = ÜTG - ÇTG):</span>
            <strong>{calcData.BTG} gün</strong>
          </li>
          <li>
            <span>{t(calc3Ext.totalEarnings, language)}</span>
            <strong>{calcData.ÜQM.toFixed(2)} ₼</strong>
          </li>
          <li>
            <span>{t(calc3Ext.dailyAverage, language)}</span>
            <strong>{calcData.OQM.toFixed(2)} ₼ / gün</strong>
          </li>
          <li>
            <span>{t(calc3Ext.leaveCalDays, language)}</span>
            <strong>{calcData.TGS} gün</strong>
          </li>
          <li>
            <span>{t(calc3Ext.seniorityStatus, language)}</span>
            <strong style={{ color: calcData.isEligibleSeniority ? '#059669' : '#b45309' }}>
              {calcData.seniorityMonths} ay ({calcData.isEligibleSeniority ? 'Şərt ödənilib' : 'Xüsusi yoxlama tələb olunur'})
            </strong>
          </li>
          <li>
            <span>{t(calc3Ext.taxExempt, language)}</span>
            <strong style={{ color: '#059669' }}>{t(calc3Ext.yesTaxExempt, language)}</strong>
          </li>
        </ul>
      </div>

      {/* Official Disclaimer */}
      <div className={styles.disclaimerCard}>
        <h4>{t(calc3Ext.legalNoticeTitle, language)}</h4>
        <p>
          Kalkulyatorun əsas hesablanma mexanizmi və təqdim edilmiş test ssenariləri üzrə tətbiqi aktual normativ tələblərlə uyğunlaşdırılmışdır. Kalkulyator məlumatlandırıcı ilkin hesablama vasitəsidir; faktiki müavinətin təyinatı və məbləği DSMF/ƏMAS elektron məlumatları və həmin tarixdə qüvvədə olan qanunvericilik əsasında müəyyən edilir.
        </p>
      </div>

      {/* Buttons */}
      <div className={styles.buttons}>
        <Button to={'/useful/calculator/3'}>
          {t(calcCommon.recalculateBtn, language).toUpperCase()}
        </Button>
        <FormButton onClick={generatePdf}>
          {t(calcCommon.downloadPdfBtn, language).toUpperCase()}
        </FormButton>
      </div>
    </section>
  ) : (
    <Loading />
  )
}

export default Result3
